export const BASE_URL = process.env.REACT_APP_API;
export const BASE_URL_IMG = process.env.REACT_APP_AWS;
export const SIGNER_URL = process.env.REACT_APP_SIGNER_URL;
export const AWS_KEY = process.env.REACT_APP_AWS_KEY;
export const AWS_BUCKET = process.env.REACT_APP_BUCKET;
export const AWS_REGION = process.env.REACT_APP_AWS_REGION;
